import type { OrganizationRole } from './api/schemas';

const ORGANIZATION_MANAGER_ROLES: OrganizationRole[] = ['owner', 'admin'];
const ORGANIZATION_OWNER_ROLES: OrganizationRole[] = ['owner'];

export function canManageOrganization(role: OrganizationRole | null | undefined): boolean {
    return Boolean(role && ORGANIZATION_MANAGER_ROLES.includes(role));
}

export function canManageOrganizationBilling(role: OrganizationRole | null | undefined): boolean {
    return Boolean(role && ORGANIZATION_OWNER_ROLES.includes(role));
}

export function canManageOrganizationMembers(role: OrganizationRole | null | undefined): boolean {
    return canManageOrganization(role);
}

export function canManageOrganizationInvitations(role: OrganizationRole | null | undefined): boolean {
    return canManageOrganization(role);
}

export function canManageOrganizationApiKeys(role: OrganizationRole | null | undefined): boolean {
    return canManageOrganization(role);
}
